var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6602 1.16717C15.0202 -0.632832 11.7602 0.207168 10.0002 2.26717C8.24021 0.207168 4.98021 -0.642832 2.34021 1.16717C0.940213 2.12717 0.0602132 3.74717 0.000213223 5.45717C-0.139787 9.33717 3.30021 12.4472 8.55021 17.2172L8.65021 17.3072C9.41021 17.9972 10.5802 17.9972 11.3402 17.2972L11.4502 17.1972C16.7002 12.4372 20.1302 9.32717 20.0002 5.44717C19.9402 3.74717 19.0602 2.12717 17.6602 1.16717ZM10.1002 15.7272L10.0002 15.8272L9.90021 15.7272C5.14021 11.4172 2.00021 8.56717 2.00021 5.67717C2.00021 3.67717 3.50021 2.17717 5.50021 2.17717C7.04021 2.17717 8.54021 3.16717 9.07021 4.53717H10.9402C11.4602 3.16717 12.9602 2.17717 14.5002 2.17717C16.5002 2.17717 18.0002 3.67717 18.0002 5.67717C18.0002 8.56717 14.8602 11.4172 10.1002 15.7272Z",
    fill: "#CFD2D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyheart);
export default __webpack_public_path__ + "static/media/empty.heart.9be9eddb56b3f15a1324eee0dd72b7ec.svg";
export { ForwardRef as ReactComponent };